import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _component = require("../_utils/component");

var _Modal = _interopRequireDefault(require("../Modal"));

var _chooseIndustry = _interopRequireDefault(require("./components/choose-industry"));

var _chooseProfession = _interopRequireDefault(require("./components/choose-profession"));

var _loadingMask = _interopRequireDefault(require("./components/loading-mask"));

var _request = _interopRequireDefault(require("../request"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('user-preference'),
  components: {
    Modal: _Modal.default,
    ChooseIndustry: _chooseIndustry.default,
    ChooseProfession: _chooseProfession.default,
    LoadingMask: _loadingMask.default
  },
  mixins: [_component.componentMixin],
  props: {
    // 弹框显示
    visible: {
      type: Boolean,
      default: false
    },
    // 用户session
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onCancel: {
      type: Function
    }
  },

  data() {
    return {
      industryOptions: null,
      professionOptions: null,
      chosenIndustryOptions: null,
      chosenProfessionOptions: null,
      shownType: 'industry',
      width: '720px',
      innerVisible: false,
      loading: false
    };
  },

  computed: {// innerVisible: {
    //     get() {
    //         return this.visible;
    //     },
    //     set(visible) {
    //         this.$emit('update:visible', visible);
    //     }
    // },
  },
  watch: {
    'visible': {
      handler(visible) {
        if (visible) {
          this.innerVisible = visible;
          this.getOptions();
          this.markHasWarn();
        }

        ;
      },

      immediate: true
    }
  },
  methods: {
    getOptions() {
      var _this = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var allRequest, chosenRequest, _ref, allOptions, chosenOptions;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                allRequest = _request.default.get('/api/preferences', {
                  params: {
                    page_size: 100
                  }
                });
                chosenRequest = _request.default.get("/api/users/" + _this.user.id + "/preferences", {
                  params: {
                    // user_id: this.user.id,
                    page_size: 100,
                    with_preference: 1
                  }
                });
                _context.next = 5;
                return _promise.default.all([allRequest, chosenRequest]);

              case 5:
                _ref = _context.sent;
                allOptions = _ref[0];
                chosenOptions = _ref[1];

                _this.setIndustryOptions(allOptions.data);

                _this.setProfessionOptions(allOptions.data);

                _this.setChosenIndustryOptions(chosenOptions.data);

                _this.setChosenProfessionOptions(chosenOptions.data);

                _this.loading = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    getChosenOptions() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var chosenOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _request.default.get("/api/users/" + _this2.user.id + "/preferences", {
                  page_size: 100,
                  with_preference: 1
                });

              case 2:
                chosenOptions = _context2.sent;
                _this2.chosenOptions = chosenOptions.data.map(function (option) {
                  return {
                    recordId: option.id,
                    preference_id: option.preference_id
                  };
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    chooseIndustry(param) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var paramMap;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // const resMap = {
                //     update: 'updateUserPreferences',
                //     create: 'createUserPreferences',
                //     delete: 'deleteUserPreferences',
                // };
                paramMap = {
                  update: function update() {
                    return _request.default.put("/api/users/" + _this3.user.id + "/preferences/" + String(param.recordId), {
                      preference_id: param.id,
                      type: 'industry'
                    });
                  },
                  create: function create() {
                    return _request.default.post("/api/users/" + _this3.user.id + "/preferences", {
                      preference_id: param.id,
                      type: 'industry'
                    });
                  },
                  delete: function _delete() {
                    return _request.default.delete("/api/users/" + _this3.user.id + "/preferences/" + String(param.recordId), {
                      type: 'industry'
                    });
                  }
                };
                _context3.next = 3;
                return paramMap[param.type]();

              case 3:
                if (param.chosen) _this3.shownType = 'profession';

                _this3.getOptions();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    chooseProfession(param) {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _request.default.post("/api/users/" + _this4.user.id + "/preferences/batch", (0, _assign.default)({}, param));

              case 2:
                _this4.closeDialog();

                _this4.$emit('success');

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    setIndustryOptions(allOptions) {
      this.industryOptions = allOptions.filter(function (option) {
        return option.type === 'industry';
      }).concat({
        name: '其他',
        id: 0
      });
    },

    setProfessionOptions(allOptions) {
      this.professionOptions = allOptions.filter(function (option) {
        return option.type === 'profession';
      }).concat({
        name: '其他',
        id: 0
      });
    },

    setChosenIndustryOptions(chosenOptions) {
      var options = chosenOptions.filter(function (option) {
        return option.type === 'industry';
      });
      this.chosenIndustryOptions = options.map(function (option) {
        return {
          recordId: option.id,
          preference_id: option.preference_id
        };
      });
    },

    setChosenProfessionOptions(chosenOptions) {
      var options = chosenOptions.filter(function (option) {
        return option.type === 'profession';
      });
      this.chosenProfessionOptions = options.map(function (option) {
        return {
          recordId: option.id,
          preference_id: option.preference_id
        };
      });
    },

    showProfessionOptions() {
      this.shownType = 'profession';
    },

    showIndustryOptions() {
      this.shownType = 'industry';
    },

    closeDialog() {
      this.innerVisible = false;
    },

    markHasWarn() {
      if (!localStorage.getItem('has-warn-preference')) {
        localStorage.setItem('has-warn-preference', 'true');
      }

      ;
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Modal", {
    class: _vm.bem(),
    attrs: {
      centered: "",
      visible: _vm.innerVisible,
      showCloseButton: true,
      maskClosable: false,
      showNewClose: true,
      onCancel: _vm.onCancel,
      width: _vm.width
    },
    on: {
      "update:visible": [function ($event) {
        _vm.innerVisible = $event;
      }, function (v) {
        return _vm.$emit("update:visible", v);
      }]
    }
  }, [_vm.industryOptions && _vm.professionOptions && _vm.chosenIndustryOptions && _vm.chosenProfessionOptions ? [_c("choose-industry", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shownType === "industry",
      expression: "shownType === 'industry'"
    }],
    attrs: {
      allOptions: _vm.industryOptions,
      chosenOptions: _vm.chosenIndustryOptions
    },
    on: {
      chooseOption: _vm.chooseIndustry,
      closeDialog: _vm.closeDialog,
      showProfessionOptions: _vm.showProfessionOptions
    }
  }), _vm._v(" "), _c("choose-profession", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shownType === "profession",
      expression: "shownType === 'profession'"
    }],
    attrs: {
      allOptions: _vm.professionOptions,
      chosenOptions: _vm.chosenProfessionOptions
    },
    on: {
      chooseOption: _vm.chooseProfession,
      closeDialog: _vm.closeDialog,
      showIndustryOptions: _vm.showIndustryOptions
    }
  })] : _vm._e(), _vm._v(" "), _c("loading-mask", {
    attrs: {
      loading: _vm.loading,
      minHeight: 272
    }
  })], 2);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;